import { BetrokkenStation, BetrokkenStationsBetrokkenheid } from "@/entities/betrokken-stations";
import { useGetStationDisplayName } from "@/entities/station";
import { BETROKKENHEID_LABELS } from "../constants";
import { BetrokkenStationChip } from "./betrokken-station-chip";

type BetrokkenStationsGroupProps = {
    betrokkenheidType: BetrokkenStationsBetrokkenheid;
    stations: BetrokkenStation[];
    onRemoveStation?: (stationCode: string) => void;
    removingStationCode?: string | null;
};

export function BetrokkenStationsGroup({
    betrokkenheidType,
    stations,
    onRemoveStation,
    removingStationCode,
}: Readonly<BetrokkenStationsGroupProps>) {
    const getStationDisplayName = useGetStationDisplayName("stationCodeSuffixed");

    if (stations.length === 0) {
        return null;
    }

    const sortedStations = [...stations].sort((a, b) => a.stationsCode.localeCompare(b.stationsCode));
    const isRemovable = betrokkenheidType === BetrokkenStationsBetrokkenheid.HANDMATIG && !!onRemoveStation;

    return (
        <div className="space-y-2" data-testid={`betrokken-stations-group-${betrokkenheidType}`}>
            <h4>{BETROKKENHEID_LABELS[betrokkenheidType]}</h4>
            {isRemovable ? (
                <div className="flex flex-wrap gap-2">
                    {sortedStations.map((station) => (
                        <BetrokkenStationChip
                            key={station.stationsCode}
                            stationCode={station.stationsCode}
                            label={getStationDisplayName(station.stationsCode)}
                            onRemove={() => onRemoveStation(station.stationsCode)}
                            disabled={removingStationCode === station.stationsCode}
                        />
                    ))}
                </div>
            ) : (
                <p className="text-content-primary">
                    {sortedStations.map((station) => getStationDisplayName(station.stationsCode)).join(", ")}
                </p>
            )}
        </div>
    );
}
